import { Ref } from 'react';

export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export interface RadioButtonOption {
    value: string;
    label?: string;
    description?: string;
    id?: string;
    ref?: Ref<HTMLInputElement>;
}

export enum PinChangeOption {
    KEEP_PIN = 'KEEP_PIN',
    CHANGE_PIN = 'CHANGE_PIN',
}
